; (function (global, factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        factory(module, global);
    } else {
        factory({}, global);
    }
})(window || this, function (module, window) {

    // 是否微信
    var isWx = /micromessenger/i.test(navigator.userAgent);

    // 动态加载
    function getScript(url, callback, charset) {
        var script = document.createElement("script");
        charset = charset || 'utf-8';
        script.type = "text/javascript";
        script.charset = charset;

        script.onload = script.onreadystatechange = function () {
            if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
                callback && callback();
                script.onload = script.onreadystatechange = null;
                script.parentNode.removeChild(script);
            }
        };

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    function app() {
        // 引导分享蒙层
        this.shareStyle = document.createElement('style');
        this.shareStyle.type = 'text/css';
        this.shareStyle.innerHTML = '.mask-share-tips{display: none;background:rgba(0, 0, 0, .8);position: fixed;top:0;left:0;right:0;bottom: 0;z-index: 9999}.mask-share-tips img{display: block;width: 100%;}';
        document.getElementsByTagName('head')[0].appendChild(this.shareStyle);

        this.shareElem = document.createElement('div');
        this.shareElem.className = 'mask-share-tips';
        this.shareElem.innerHTML = '<img src="//picture.eclicks.cn/kaojiazhao/public/h5/images/share.png" alt=""/>';
        document.body.appendChild(this.shareElem);

        this.shareElem.onclick = function () {
            this.style.display = 'none';
        };

        // 是否微信中打开
        this.isWx = isWx;

        // 任务初始化
        this.initTask();

        // 加载js库
        this.isReady = false;
        this.load();

    }


    /**
     * 加载wx库
     */
    app.prototype.load = function () {
        var _self = this;
        if (_self.isWx) {
            getScript('https://res.wx.qq.com/open/js/jweixin-1.0.0.js', function () {
                wx.ready(function () {
                    _self.isReady = true;
                    console.info("weixin is ready!122");

                    _self.task.emit();
                });

                var isTest = ['xch5.chelun.com', 'picture.eclicks.cn', 'lk.chelun.com','lkpre.ailky.com', 'lkpre.chelun.com'].indexOf(location.hostname) == -1;
                // 从sessionStorage获取is_shengPay并转换为数字类型
                var is_shengPay = sessionStorage.getItem('is_shengPay');
                // 转换为数字并进行有效性检查
                var shengPayValue = parseInt(is_shengPay);
                // 如果解析失败或不是数字，则默认为0
                if (isNaN(shengPayValue)) {
                    shengPayValue = 0;
                }
                var configUrl = '';
                if (shengPayValue == 1) {
                    // 盛付通支付 - 使用TYWxSDK/config
                    configUrl = isTest ? 'http://lkapidev.ailky.com/TYWxSDK/config?t=' : 'https://lkapi.chelun.com/TYWxSDK/config?t='; // 假设生产环境也使用相同的域名
                } else {
                    // 标准支付 - 使用wechat/config
                    configUrl = isTest ? 'http://kjzdev.eclicks.cn/kaojiazhao2/xc_v3/H5api/wxconfig?t=' : 'https://xueche.chelun.com/xc_v1/wechat/config?t=';
                }
                console.log(configUrl, '=configUrl111');
                getScript(configUrl + Date.parse(new Date));
            });
        }
    };

    /**
     *  任务
     */
    app.prototype.initTask = function () {
        var _self = this;

        _self.task = function () {
            var task = {
                handlers: {},

                on: function (fnName, param) {
                    if (fnName) {
                        if (!(fnName in task.handlers)) {
                            task.handlers[fnName] = [];
                        }
                        task.handlers[fnName].push(param);
                    }

                    return task;
                },
                emit: function () {
                    for (var fnName in task.handlers) {
                        if (task.handlers.hasOwnProperty(fnName)) {
                            for (var i in task.handlers[fnName]) {
                                var param = task.handlers[fnName][i];
                                _self[fnName](param);
                                console.info(fnName + ': %o', param);
                            }
                        }
                    }
                    task.handlers = {};

                    return task;
                }
            };
            return task;
        }();
    };

    /**
     * 设置右上角菜单分享
     * @param param
     * title
     * timeline
     * desc
     * imgUrl
     * link
     * success
     * fail
     */
    app.prototype.setMenuShare = function (param) {
        var _self = this;
        if (!_self.isWx) return;

        if (!_self.isReady) {
            _self.task.on('setMenuShare', param);
            return;
        }

        wx.onMenuShareAppMessage({
            title: param.title,
            desc: param.desc,
            imgUrl: param.imgUrl,
            link: param.link,
            success: function () {
                param.success && param.success('好友');
            },
            fail: function () {
                param.fail && param.fail('好友');
            }
        });

        wx.onMenuShareTimeline({
            title: param.timeline,
            imgUrl: param.imgUrl,
            link: param.link,
            success: function () {
                param.success && param.success('朋友圈');
            },
            fail: function () {
                param.fail && param.fail('朋友圈');
            }
        });

        wx.onMenuShareQZone({
            title: param.title,
            desc: param.desc,
            imgUrl: param.imgUrl,
            link: param.link,
            success: function () {
                param.success && param.success('QQ空间');
            },
            fail: function () {
                param.fail && param.fail('QQ空间');
            }
        });

        wx.onMenuShareQQ({
            title: param.title,
            desc: param.desc,
            imgUrl: param.imgUrl,
            link: param.link,
            success: function () {
                param.success && param.success('QQ');
            },
            fail: function () {
                param.fail && param.fail('QQ');
            }
        });
    };

    /**
     * 弹出蒙层，引导用户分享
     * @param param
     * title
     * timeline
     * desc
     * imgUrl
     * link
     * success
     * fail
     */
    app.prototype.share = function (param) {
        var _self = this;
        if (!_self.isWx) return;

        if (!_self.isReady) {
            _self.task.on('share', param);
            return;
        }

        _self.setMenuShare(param);

        //alert('点击右上角菜单分享~');
        _self.prompt();
    };

    app.prototype.prompt = function () {
        var _self = this;
        _self.shareElem.style.display = 'block';
    };

    /**
     * 支付
     */
    app.prototype.pay = function (param, cb) {
        wx.chooseWXPay({
            timestamp: param.timeStamp,
            nonceStr: param.nonceStr,
            package: param.package,
            signType: param.signType,
            paySign: param.paySign,
            success: function () {
                cb && cb();
            }
        });
    };

    /**
     * 隐藏右上角菜单项
     */
    app.prototype.hideMenus = function (param) {
        var _self = this;
        if (!_self.isWx) return;

        if (!_self.isReady) {
            _self.task.on('hideMenus', param);
            return;
        }
        wx.hideMenuItems({
            menuList: param // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
    }

    /**
     * 微信扫一扫
     * @param  {Function} cb [description]
     * @param  {type} type [description]
     * @return {[type]}      [description]
     */
    app.prototype.scanQRCode = function (type, cb) {
        wx.scanQRCode({
            needResult: type, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                cb(result)
            },
            fail: function (err) {
                cb(err)
            }
        });
    }


    /**
     * 微信中自动播放音乐
     */
    app.prototype.autoplaymusic = function (media) {
        var _self = this;
        if (!_self.isWx) return;

        if (!_self.isReady) {
            _self.task.on('autoplaymusic', media);
            return;
        }
        media.play();
    }

    window._wx = module.exports = new app;
});


//////////////////
// WEBPACK FOOTER
// ./static/js/chelun-wx-1.6.js
// module id = K5Ha
// module chunks = 1